import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeAlertDate = async ({ id, value }) => {
  return await request.put(
    `/Request/set_alert_date`,
    {
      requestId: id,
      alertDate: value,
    },
    'При изменении даты контроля произошла ошибка',
    'Error'
  );
};

const useChangeAlertDate = () => {
  const mutation = useMutation(changeAlertDate, {});

  return {
    isLoading: mutation.isLoading,
    onChange: mutation.mutateAsync,
  };
};

export default useChangeAlertDate;
